import { Calendar as BigCalendar, dateFnsLocalizer, Views, EventPropGetter } from 'react-big-calendar';
import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';
import { startOfWeek } from 'date-fns/startOfWeek';
import { getDay } from 'date-fns/getDay';
import { enUS } from 'date-fns/locale/en-US';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './calendar.css';
import { useMemo } from 'react';

const locales = {
  'en-US': enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

export interface CalendarEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  type?: 'TOURNAMENT' | 'NORMAL';
  phase?: 'GROUP_PHASE' | 'ELIMINATION_PHASE' | null;
  assigned?: boolean;
  tournament?: { id: string; name: string } | null;
}

interface CalendarProps {
  events: CalendarEvent[];
  date: Date;
  onNavigate: (date: Date) => void;
}

export function Calendar({ events, date, onNavigate }: CalendarProps) {
  const eventStyleGetter: EventPropGetter<CalendarEvent> = useMemo(
    () => (event) => {
      let backgroundColor = '#6b7280'; // gray-500 for normal
      let borderColor = '#4b5563'; // gray-600

      if (event.type === 'TOURNAMENT') {
        if (event.phase === 'GROUP_PHASE') {
          backgroundColor = '#3b82f6'; // blue-500
          borderColor = '#2563eb'; // blue-600
        } else if (event.phase === 'ELIMINATION_PHASE') {
          backgroundColor = '#f59e0b'; // amber-500
          borderColor = '#d97706'; // amber-600
        }
      }

      return {
        style: {
          backgroundColor,
          borderColor,
          borderLeft: `4px solid ${borderColor}`,
          borderRadius: '4px',
          color: 'white',
          fontSize: '12px',
        },
      };
    },
    []
  );

  return (
    <BigCalendar
      date={date}
      defaultView={Views.DAY}
      localizer={localizer}
      views={{ day: true }}
      style={{
        height: '100%',
        overflow: 'hidden',
      }}
      toolbar={false}
      onNavigate={onNavigate}
      events={events}
      scrollToTime={new Date()}
      eventPropGetter={eventStyleGetter}
    />
  );
}
